import browser from './browser';
import urlExt from './url';
import { extend, isEmptyObject, isPlainObject } from './common';

const commonData = {};
const inApp = /college/i.test(navigator.userAgent);
const inZybApp = /homework/i.test(navigator.userAgent);
const uaExt = {
  _isKeyValid(key: string) {
    return /college/i.test(navigator.userAgent) && new RegExp('college_').test(key);
  },
  getRaw(key: string) {
    if (uaExt._isKeyValid(key)) {
      return null;
    }
    const reg = new RegExp('college_' + key + '/([^\\s]*)');
    const result = reg.exec(navigator.userAgent);
    return (result && result[1]) || null;
  },
  get(key: string) {
    const value = uaExt.getRaw(key);
    return value ? decodeURIComponent(value) : null;
  },
  getHomework(key: string) {
    const reg = new RegExp('homework_' + key + '/([^\\s]*)');
    const result = reg.exec(navigator.userAgent);
    return (result && result[1]) || null;
  }
};
const _naData =
  !inApp && !inZybApp
    ? {}
    : {
        i: !inZybApp ? uaExt.get('cuid') : uaExt.getHomework('cuid'),
        vc: !inZybApp ? uaExt.get('vc') : uaExt.getHomework('vc'),
        av: !inZybApp ? uaExt.get('vcname') : uaExt.getHomework('vcname'),
        c: !inZybApp ? uaExt.get('channel') : uaExt.getHomework('channel')
      };
const _isPrimitive = (arg: string | null | undefined) => {
  const type = typeof arg;
  return arg != null && type !== 'object' && type !== 'function';
};
const logger = {
  send(data: { [index: string]: any }, name?: string): Promise<unknown> | void {
    // eslint-disable-line
    if (data && isPlainObject(data) && !isEmptyObject(data)) {
      if (!_isPrimitive(name) && !_isPrimitive(data.name)) {
        throw Error('name is invalid, please check');
      }
      return new Promise<void>(resolve => {
        const image = new Image();
        image.onload = function () {
          resolve();
        };
        image.onerror = function () {
          resolve();
        };
        const logUrl =
          'https://nlog.daxuesoutijiang.com/log/daxuesouti_h5/notice.gif?' +
          urlExt.jsonToQuery(
            extend(
              {
                pid: 1,
                name: data.name || name,
                page: document.documentElement.getAttribute('page'),
                url: location.origin + location.pathname,
                os: browser.os(),
                browser: browser.kernel(),
                elapse: window.logger_pageStartTime ? Number(new Date()) - window.logger_pageStartTime : 0,
                screen: (screen.width || 0) + '_' + (screen.height || 0),
                type: 'custom',
                refer: document.referrer
              },
              commonData,
              _naData,
              data
            ),
            true
          );
        console.log('非全埋点位上报：' + logUrl);
        image.src = logUrl;
      });
    }
  }
};

export const $logger = logger;

export default logger;
